import { render } from "./bmsProjectUpdates.vue?vue&type=template&id=fce4fc00&scoped=true"
import script from "./bmsProjectUpdates.vue?vue&type=script&lang=js"
export * from "./bmsProjectUpdates.vue?vue&type=script&lang=js"

import "./bmsProjectUpdates.vue?vue&type=style&index=0&id=fce4fc00&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce4fc00"]])

export default __exports__